import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71d79e56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = ["src"]



export default /*#__PURE__*/_defineComponent({
  __name: 'NotYetOpen',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as { data: string };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("img", {
        src: 
          props.data == '暂未开放，敬请期待!'
            ? require('../assets/notYetOpen.png')
            : require('../assets/noConnect.png')
        
      }, null, 8, _hoisted_2),
      _createElementVNode("h1", null, _toDisplayString(props.data), 1)
    ])
  ]))
}
}

})